module.exports = __webpack_public_path__ + "static/media/3 Chouhan Fallow Land Brief.93a49e1e.pdf";